<template>
  <v-card>
    <v-card-title>
      <div class="card-title">
        <div class="card-title-left">Team Members Status</div>
        <div class="card-title-right">
          <v-btn variant="text" icon="mdi-close" @click="close" />
        </div>
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <Bubble :data="chartData" :options="chartOptions" />
    </v-card-text>
  </v-card>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { Chart as ChartJS, Tooltip, Legend, PointElement, LinearScale } from 'chart.js';
import { Bubble } from 'vue-chartjs';
import { BubbleChartDataset, BubbleChartOptions } from '../../models/BubbleChart';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend)

export default defineComponent({
  components: { Bubble },
  props: ["labelsCount"],
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true
      } as BubbleChartOptions,
      chartData: {
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#F44336',
            data: [
              {
                x: 1,
                y: this.labelsCount[1],
                r: this.labelsCount[1]
              },
            ]
          },
          {
            label: 'Data Two',
            backgroundColor: '#ff9800',
            data: [
              {
                x: 2,
                y: this.labelsCount[2],
                r: this.labelsCount[2]
              },
            ]
          },
          {
            label: 'Data Three',
            backgroundColor: '#4CAF50',
            data: [
              {
                x: 3,
                y: this.labelsCount[3],
                r: this.labelsCount[3]
              },
            ]
          }
        ]
      } as { datasets: BubbleChartDataset[] },
    };
  },
  methods: {
    close(): void {
      this.$emit("close");
    },
  },
  async mounted() {
  }
});
</script>
<style lang="scss" scoped>
.section {
  border: 1px solid #e6e6e6;
  border-radius: 5px;
}

.section:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.5);
}

.message {
  text-align: center;
}

.epicList {
  height: 225px;
  overflow-x: auto;
}

.addEpicBut {
  width: 100%;
}

.editEpicBut {
  color: black;
}

.tagContainer {
  color: silver;
  padding: 20px 10px;
  margin-top: -10px;
  border: 1xp solid #efefef;
  border-radius: 4px;

  &>legend {
    padding: 0 5px;
  }

  &>.tag {
    display: inline-block;
    padding: 5px 10px;
    border: 1px solid silver;
    border-radius: 20px;
    margin: 2px;
    background-color: #00e;
    color: #fefefe;
  }
}
</style>
